import { io } from 'socket.io-client'
import { BACKEND } from './api'

let socket = null

export function getSocket() {
  if (socket) return socket
  const token = localStorage.getItem('token')
  if (!token) return null
  socket = io(BACKEND, { auth: { token }, transports: ['websocket', 'polling'] })
  socket.on('connect', () => console.log('🔌 Socket conectado'))
  socket.on('disconnect', () => console.log('🔌 Socket desconectado'))
  return socket
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
